import { resourcesAsResourceMap } from 'components/helpers/serialisableResources';

export function formatInfiniteData({ data, resourceTypes }) {
  const included =
    resourceTypes?.length ?
      resourcesAsResourceMap({
        resources: data.pages.map((page) => page.included || []).flat(),
        resourceTypes,
      })
    : {};

  return {
    data: data.pages.map((page) => page.data).flat(),
    included,
    meta: data.pages.at(-1).meta,
  };
}

export function getNextPageParam(lastPage, pages) {
  const { currentPage, totalPages } = lastPage.meta;

  return currentPage !== totalPages ? pages.length + 1 : undefined;
}
